import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../views/Landing.vue'
import Enterprise from '../views/Enterprise.vue'
import Student from '../views/Student.vue'
import Investor from '../views/Investor.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import AdminContacts from '../views/AdminContacts.vue'

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    meta: {
      title: '索原 | AI驱动的项目能力验证与高可信任务协作平台',
      description: '把真实项目变成可验证的能力证明，连接大学生、企业与真实业务场景'
    }
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    component: Enterprise,
    meta: {
      title: '企业解决方案 | 索原 - 高可信企业任务外包与人才能力验证',
      description: '为企业提供AI驱动的高可信任务外包与人才能力验证平台，构建完整的风控体系'
    }
  },
  {
    path: '/student',
    name: 'Student',
    component: Student,
    meta: {
      title: '技能成长 | 索原 - 把真实项目变成可验证能力履历',
      description: '为学生提供真实企业任务机会，构建可验证的能力履历，实现可信的能力验证'
    }
  },
  {
    path: '/student-guide',
    name: 'StudentGuide',
    component: () => import('../views/StudentGuide.vue'),
    meta: {
      title: '技能成长指南 | 索原',
      description: '从注册到接单、从任务到认证，一步步带你上手 Skillith 技能成长平台'
    }
  },
  {
    path: '/investor',
    name: 'Investor',
    component: Investor,
    meta: {
      title: '商业模式 | 索原 - AI能力验证平台的增长逻辑与市场空间',
      description: '了解索原的商业模式、市场空间、竞争护城河与发展路线'
    }
  },
  {
    path: '/whitepaper',
    name: 'Whitepaper',
    component: () => import('../views/Whitepaper.vue'),
    meta: {
      title: '白皮书 | 索原',
      description: '索原技术白皮书与商业模式详解'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们 | 索原 - 真源真源的使命与核心价值',
      description: '了解索原的团队、文化、使命与核心价值'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: '联系我们 | 索原 - 企业合作与商务洽谈',
      description: '联系索原团队，探讨企业合作、投资交流与技术集成机会'
    }
  },
  {
    path: '/admin/contacts',
    name: 'AdminContacts',
    component: AdminContacts,
    meta: {
      title: '商务联系管理 | 索原',
      description: '查看官网商务联系表单提交记录',
      robots: 'noindex, nofollow'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 全局路由守卫：更新页面 meta 信息（title、description、robots）+ 简单管理页访问控制
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.description)
  const nearestWithRobots = to.matched.slice().reverse().find(r => r.meta && r.meta.robots)

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  }
  if (nearestWithMeta) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', nearestWithMeta.meta.description)
    }
  }

  // 禁止爬虫的页面（如管理后台）：设置 noindex, nofollow；其他页面不设或恢复为可收录
  let metaRobots = document.querySelector('meta[name="robots"]')
  if (nearestWithRobots && nearestWithRobots.meta.robots) {
    if (!metaRobots) {
      metaRobots = document.createElement('meta')
      metaRobots.setAttribute('name', 'robots')
      document.head.appendChild(metaRobots)
    }
    metaRobots.setAttribute('content', nearestWithRobots.meta.robots)
  } else if (metaRobots) {
    metaRobots.remove()
  }

  next()
})

export default router
